import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "swiper-container" }
const _hoisted_2 = { class: "swiper-container-wrapper-row" }
const _hoisted_3 = { class: "swiper-container-wrapper-row-items-box" }

import { nextTick, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SwiperComponent',
  props: {
    items: {},
    childrenClass: {}
  },
  setup(__props: any) {

const props = __props;

const isScrolledToEnd = ref(false);
const isScrolledToStart = ref(true);
const dataSwipe = ref<HTMLElement | null>(null);

const deviceHasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

watch(
  () => props.items,
  () => {
    handleScrolling();
  },
  { immediate: true, deep: true }
);

function nextData() {
  const items = document.querySelectorAll(props.childrenClass);

  if (!dataSwipe.value || items.length === 0) {
    return;
  }

  const itemWidth = (items[0] as HTMLElement).offsetWidth;
  const visibleItems = dataSwipe.value!.clientWidth / itemWidth;

  const currentScrollPosition = Math.round(dataSwipe.value!.scrollLeft / itemWidth);
  const nextPosition = currentScrollPosition + Math.floor(visibleItems);

  dataSwipe.value!.scrollTo({
    left: nextPosition * itemWidth,
    behavior: 'smooth',
  });
}

function previousData() {
  const items = document.querySelectorAll(props.childrenClass);

  if (!dataSwipe.value || items.length === 0) {
    return;
  }

  const itemWidth = (items[0] as HTMLElement).offsetWidth;
  const visibleItems = dataSwipe.value!.clientWidth / itemWidth;

  const currentScrollPosition = Math.round(dataSwipe.value!.scrollLeft / itemWidth);
  const nextPosition = currentScrollPosition - Math.floor(visibleItems);

  dataSwipe.value!.scrollTo({
    left: nextPosition * itemWidth,
    behavior: 'smooth',
  });
}

function handleScrolling() {
  nextTick(() => {
    const items = document.querySelectorAll(props.childrenClass);

    if (items.length === 0 || !dataSwipe.value) {
      isScrolledToEnd.value = true;
      isScrolledToStart.value = true;
      return;
    }

    const scrollLeft = dataSwipe.value.scrollLeft;
    const totalWidth = dataSwipe.value.scrollWidth;
    const containerWidth = dataSwipe.value.clientWidth;

    if (scrollLeft <= 0) {
      isScrolledToStart.value = true;
    } else {
      isScrolledToStart.value = false;
    }
    const nearEndThreshold = 2;
    if (scrollLeft + containerWidth >= totalWidth - nearEndThreshold) {
      isScrolledToEnd.value = true;
    } else {
      isScrolledToEnd.value = false;
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(deviceHasTouch))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["arrow-box left-arrow", { 'disabled-arrow-box': isScrolledToStart.value }]),
          onClick: previousData
        }, null, 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "swiper-container-wrapper",
      ref_key: "dataSwipe",
      ref: dataSwipe,
      onScroll: handleScrolling
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "swiper-container-wrapper-row-items"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "item", { item: item })
            ])
          ]))
        }), 128))
      ])
    ], 544),
    (!_unref(deviceHasTouch))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["arrow-box right-arrow", { 'disabled-arrow-box': isScrolledToEnd.value }]),
          onClick: nextData
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}
}

})